<div [@slideInOut]="active ? 'show' : 'hide'" class="legend-animate-container">
    <div>
       <div [@.disabled]="disableAnimation()">
        <mat-accordion multi="false">

            <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.RoadAndPath"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img100k/leg1_100k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.RoadAndPath"|translate}}' width="230" height="766">
                </div>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Railway"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img100k/leg2_100k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Railway"|translate}}' width="230" height="377">
                </div>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Groundcover"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img100k/leg3_100k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Groundcover"|translate}}' width="230" height="412">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Hydrography"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img100k/leg4_100k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Hydrography"|translate}}' width="230" height="330">
                </div>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.AdministrativeData"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img100k/leg5_100k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.AdministrativeData"|translate}}' width="230" height="400">
                </div>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.RemarkableElements"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img100k/leg6_100k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.RemarkableElements"|translate}}' width="230" height="350">
                </div>
            </mat-expansion-panel>


            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Planimetry"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img100k/leg7_100k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Planimetry"|translate}}' width="230" height="510">
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>